import React, { Component } from 'react';
import _, { isEmpty, size } from "lodash"

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { newPaymentCollabCharge } from '../../../store/actions/paymentAction'

import { withStyles } from '@mui/styles';

import CloseIcon from '@mui/icons-material/Close';
import { 
    Grid ,
    Button ,
    Dialog ,
    DialogActions ,
    DialogContent ,
    Slide ,
    AppBar ,
    Toolbar ,
    IconButton ,
    Typography ,
    FormHelperText ,
    FormControl ,
    TextField ,
    OutlinedInput,
    InputLabel,
    Select,
} from '@mui/material';

import DatePicker from '../../common/DatePicker';
import ChargeReceivePayment from './ChargeReceivePayment';
import Currency from "../../common/Currency";
import InputText, { InputSelectNative } from '../../common/Form';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '100%',
    },
    root: {
        display: 'flex',
    },
    formControl: {
        width: "100%",
    },
    group: {
        flexDirection: 'row',
    },
    selectOption: {
        marginTop: theme.spacing(1),
    },
});

class ChargePaymentUserForm extends Component {
    state = { 
        payment_total_amount : this.props.payment ? this.props.payment.payment_total_amount : "",
        payment_desc : this.props.payment ? this.props.payment.payment_desc : "",
        payment_remarks: this.props.payment ? this.props.payment.payment_remarks : "",
        payment_collaborator: "",
        // payment_mode: "",
        // payment_ref: "",
        payment_date: this.props.payment ? this.props.payment.payment_date : new Date(),
        payments: [
            {
                payment_charge_id: "",
                payment_amount: "",
            }
        ],
        errors:{
            payment_total_amount: "",
            payment_collaborator: "",
            // payment_mode: "",
            payment_date: "",
            payments: [
                {
                    payment_charge_id: "",
                    payment_amount: "",
                }
            ],
        },
        filteredCharges: {},
        nbPayment: 1,
        open: false,
    }
    componentDidMount() {
        const { CHARGES, charges, employee, USERS } = this.props;
        
        if ( !isEmpty(CHARGES) && !isEmpty(charges) ){
            let payments = []
            let errors = []
            let filteredCharges = {}

            console.log('====================================');
            console.log({employee});
            console.log('====================================');
            let filteredArray = Object.values(CHARGES).filter( item => !item.salary_line_fully_paid && (item.salary_line_employee === employee) )
            filteredArray.map( item => {
                filteredCharges[item.salary_line_id] = item
            })
            charges.map( spendID => {
                payments.push({
                    payment_charge_id: spendID,
                    payment_amount: CHARGES[spendID] ? CHARGES[spendID].salary_line_rest_to_pay : "",
                })
                errors.push({
                    payment_charge_id: "",
                    payment_amount: "",
                })
            })
            let matchUser = _.find(Object.values(USERS), obj => (obj.user_employee_id === employee) )

            this.setState({
                payments,
                payment_collaborator: matchUser.user_id,
                errors:{
                    ...this.state.errors,
                    payments:errors,
                },
                nbPayment : size(charges),
                filteredCharges,
            })
        }
    }
    // FORM
    handleChange = (e) => {

        const name = e.target.name
        const value = e.target.value
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "payment_total_amount"]

        if (!floatFields.includes(name) ){
            this.setState({
                [name]: value
            })
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            this.setState({
                [name]: value
            })
        }
    }

    handleChangePayments = (name, value, index) => {
        console.log('=========== handleChangePayments ===============');
        console.log({name, value, index});
        
        let cpPayments = [].concat(this.state.payments)   
        cpPayments[index][name] = value 
        console.table(cpPayments);

        this.setState({
            ...this.state,
            payments: cpPayments
        })
    }
    handleChangeDate = (date) => {        
        this.setState({
            payment_date: date
        })
    }
    handleAddForm = () => {
        this.setState({
            nbPayment: this.state.nbPayment + 1,
            payments: [
                ...this.state.payments,
                {
                    payment_charge_id: "",
                    payment_amount: "",
                }
            ],
            errors: {
                ...this.state.errors,
                payments:[
                    ...this.state.errors.payments,{
                        payment_charge_id: "",
                        payment_amount: "",
                    } 
                ]
            },
        })
    }
    createAddForm = () => {
        const { nbPayment, payments, filteredCharges } = this.state
        
        let selected = payments.map( item => item.payment_charge_id)
        let tab = []
        for(let i = 0; i < nbPayment; i++){
            tab.push(
                <ChargeReceivePayment
                    {...this.state.payments[i]}
                    CHARGES={filteredCharges}
                    SALARY_CATS={this.props.SALARY_CATS}
                    EMPLOYEES={this.props.EMPLOYEES}
                    SALARIES={this.props.SALARIES}
                    selected={selected}
                    charge={filteredCharges[payments[i].payment_charge_id]}
                    errors={this.state.errors.payments[i]} 
                    handleChange={this.handleChangePayments} 
                    index={i} 
                />
            )
        }
        return tab
    }
    
    validatePayments = () => {
        const { CHARGES } = this.props;
        let payments = [].concat(this.state.payments)
        let required = [
            "payment_amount",
            "payment_charge_id",
        ]
        let errors = [].concat(this.state.errors.payments)
        let noError = true

        let total = 0
        payments.forEach( (pay, index) => {
            required.forEach(field => {
                if( isEmpty(pay[field]) && !pay[field] ) { 
                    console.log(`${field} is empty`)
                    noError = false
                    errors[index][field] = "Veuillez remplir ce Champ" 
                } else {
                    errors[field] = "" 
                }
            })

            let charge = CHARGES[pay.payment_charge_id]
            if (charge) {
                if (charge.salary_line_rest_to_pay < pay.payment_amount){
                    errors[index].payment_amount = `Reste à payer : ${charge.salary_line_rest_to_pay}`
                    noError = false
                } else {
                    errors[index].payment_amount = ""
                }

            }
            total += pay.payment_amount
        })
        return {
            noError, errors, total
        }
    }
    validate = () => {
        const { USERS } = this.props;
        let required = [
            "payment_total_amount",
            "payment_collaborator",
            // "payment_mode",
            // "payment_ref",
        ]
        let validPayments = this.validatePayments()
        let collab = USERS[this.state.payment_collaborator]
        let noError = validPayments.noError
        let errors = [].concat(this.state.errors)
        errors.payments = validPayments.errors
        

        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        if (parseFloat(this.state.payment_total_amount) !== parseFloat(validPayments.total) ){
            noError = false
            errors.payment_total_amount = "Le total ne correspond pas"

        } else if (collab && collab.account < this.state.payment_total_amount){
            noError = false
            errors.payment_collaborator = "Montant insuffisant"
        }

        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.payment_date = this.state.payment_date
            data.payment_update_date = new Date()
            data.payment_total_amount =  parseFloat(this.state.payment_total_amount)
            // data.payment_mode =  this.state.payment_mode
            data.payment_collaborator =  this.state.payment_collaborator
            // data.payment_ref =  this.state.payment_ref
            data.payment_remarks =  this.state.payment_remarks
            data.payments_charges =  this.state.payments
            
            console.log('====================================');
            console.log("submit payment", {data});
            console.log('====================================');
            await this.props.newPaymentCollabCharge(data)

            // // if NoErrors ...
            if(this.props.STATE.payments.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.payments.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        console.log("New payment PROPS", this.props);
        
        const { USERS } = this.props;

        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
       
        return (
            <div>
                
                <Dialog
                    // disableBackdropClick
                    open={true}
                    // onClose={this.props.handleClose}
                    onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                    aria-labelledby="form-dialog-title"
                    fullScreen
                    TransitionComponent={Transition}
                    scroll="body"
                >
                    <AppBar style={{position: 'relative'}} color="secondary">
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit">
                                Nouveau Paiement Collaborateur
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent  style={{overflow: "hidden"}}>
                        <div >              
                            <Grid container>
                                <Grid container item xs={12} sm={6}>
                                    <Grid item xs={12}>
                                        <FormControl required error={!!this.state.errors.payment_date} style={{width:"100%"}}>
                                            <DatePicker  
                                                id="payment_date"
                                                label="Date de Paiement"
                                                name="payment_date"
                                                value={this.state.payment_date}
                                                error={!!this.state.errors.payment_date}
                                                helperText={this.state.errors.payment_date}
                                                handleChange={this.handleChangeDate} 
                                            />
                                            <FormHelperText >{this.state.errors.payment_date}</FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <InputText
                                            required
                                            onChange={this.handleChange}
                                            name="payment_total_amount" 
                                            id="payment_total_amount" 
                                            value={this.state.payment_total_amount} 
                                            label="Montant Payé" 
                                            error={this.state.errors.payment_total_amount}
                                        />
                                    </Grid>          
                                    <Grid item xs={12} >
                                        <InputSelectNative
                                            onChange={this.handleChange}
                                            error={this.state.errors.payment_collaborator}
                                            value={this.state.payment_collaborator}
                                            disabled
                                            options={ Object.values(USERS).map( user  => (
                                                <option value={user.user_id} key={user.user_id}>
                                                    {user.username} {user.lastname} -  {user.email}
                                                </option>
                                            )) }
                                            helperText2={ this.state.payment_collaborator && 
                                                <Currency value={USERS[this.state.payment_collaborator].account} />
                                            }
                                            error={this.state.errors.payment_collaborator}
                                        />
                                        {/* <FormControl variant="outlined"  error={!!this.state.errors.payment_collaborator} style={{width: "100%"}}>
                                            <InputLabel htmlFor="payment_collaborator">Collaborateur</InputLabel>
                                            <Select
                                                input={
                                                    <OutlinedInput 
                                                        labelWidth={120} 
                                                        name="payment_collaborator" 
                                                        id="payment_collaborator" 
                                                    />
                                                }
                                            >
                                                <option value="" />
                                                
                                            </Select>
                                            <FormHelperText></FormHelperText>
                                            <FormHelperText>{this.state.errors.payment_collaborator}</FormHelperText>
                                        </FormControl> */}
                                    </Grid>                                    
                                </Grid>
                                    
                                <Grid container item xs={12} sm={6}>
                                    <Grid item xs={12} >
                                        <InputText
                                            onChange={this.handleChange}
                                            rows="7"
                                            multiline
                                            name="payment_remarks" 
                                            id="payment_remarks" 
                                            value={this.state.payment_remarks} 
                                            label="Remarques" 
                                        />
                                    </Grid>
                                </Grid>                                     
                            </Grid>        
                            <Grid>
                                {this.createAddForm()}
                                <Button variant="contained" onClick={this.handleAddForm} color="primary">
                                    Ajouter une autre charge
                                </Button>
                            
                            </Grid>                             
                            <br/>
                        </div>
                                                        
                    </DialogContent>
                    <DialogActions >
                        <Button variant="contained" onClick={this.handleSubmit} color="secondary" disabled={this.props.STATE.payments.fetching}>
                            Créer
                        </Button>
                        <Button onClick={this.props.handleClose} >
                            Annuler
                            {/* <FormattedMessage id="form.cancel" defaultMessage="Annuler"/> */}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        STATE: state.request
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        newPaymentCollabCharge,
        // newUser,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChargePaymentUserForm));